import { fromNullable as fromNullableBase } from 'io-ts-types/lib/fromNullable'

export const fromNullable: typeof fromNullableBase = (codec, a, name) => {
    return fromNullableBase(codec, a, name ?? codec.name)
}
